// ZapCart brand mark — lightning bolt fused with a smart shopping cart (mint + navy)
export const ZapCartLogo = ({ size = 40, className = "" }) => (
  <div className={`rounded-2xl flex items-center justify-center ${className}`}
    style={{ width: size, height: size, background: "linear-gradient(135deg,#0B2A5B 0%,#1E3A8A 100%)" }}>
    <svg width={size * 0.62} height={size * 0.62} viewBox="0 0 32 32" fill="none">
      {/* cart body */}
      <path d="M4 6h3l2.2 12.5a2 2 0 0 0 2 1.6h9.6a2 2 0 0 0 2-1.55L27 9H8.5"
        stroke="#34D399" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      {/* wheels */}
      <circle cx="12" cy="26" r="2.2" fill="#34D399" />
      <circle cx="23" cy="26" r="2.2" fill="#34D399" />
      {/* lightning bolt inside cart */}
      <path d="M18.5 8.5 13.8 14.4h3.4l-1.6 4.6 5-6.2h-3.3z" fill="#FBBF24" stroke="#FBBF24" strokeWidth="0.6" strokeLinejoin="round" />
    </svg>
  </div>
);

export const ZapCartWordmark = ({ size = 40 }) => (
  <div className="flex items-center gap-2">
    <ZapCartLogo size={size} />
    <span className="font-extrabold tracking-tight text-slate-900" style={{ fontSize: size * 0.5 }}>
      Zap<span style={{ color: "#059669" }}>Basket</span>
    </span>
  </div>
);
